import { AppPageContentWrapper, CircularTextLoader, PageContentBox, THUNK_STATUS } from "@duosoftbg/nacid-components";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import ServiceStepper from "../common/stepper/ServiceStepper";
import { fetchLoggedUserDetails } from "../../../../store/redux/slice/AppData/loggedUser";
import { resetLibservAdditionalDocRequest } from "../../../../store/redux/slice/Forms/libservAdditionalDocForm";

const LibservAdditionalDocNew = () => {
  const dispatch = useAppDispatch();

  const libservAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.LibservAdditionalDocForm;
  });

  useEffect(() => {
    dispatch(resetLibservAdditionalDocRequest());
    dispatch(fetchLoggedUserDetails());
  }, [dispatch]);

  return (
    <AppPageContentWrapper>
      <PageContentBox>
        <Box sx={{ width: "100%" }}>
          {libservAdditionalDocForm.dataStateStatus === THUNK_STATUS.INITIAL ? (
            <ServiceStepper
              serviceSteps={libservAdditionalDocForm.steps}
              applicationSubtype={"LIBSERV_ADDITIONAL_DOCUMENTS"}
            />
          ) : (
            <CircularTextLoader />
          )}
        </Box>
      </PageContentBox>
    </AppPageContentWrapper>
  );
};

export default LibservAdditionalDocNew;
